import { store } from '../app';
import { updateInvalidations } from './reducers/invalidations';

const invalidateTags = (tags) => (result, error) => {
  tags.forEach((tag) => {
    if (!tag) console.error('Invalid tag');
  });

  if (!error) {
    store.dispatch(updateInvalidations(tags));
    return tags;
  }
  return [];
};

export default invalidateTags;
